export default __webpack_public_path__ + "ec29949af513946fa93107dd00217da0.png";